import * as Phaser from 'phaser';
import './styles.css';
import { gameConfig } from '@/config/gameConfig';
import { BootScene } from '@/scenes/BootScene';
import { PreloadScene } from '@/scenes/PreloadScene';
import { IntroScene } from '@/scenes/IntroScene';
import { GameScene } from '@/scenes/GameScene';
import { HUDScene } from '@/scenes/HUDScene';
import { GameOverScene } from '@/scenes/GameOverScene';

const container = document.getElementById('game-container');
if (!container) {
  throw new Error('Missing #game-container element in index.html');
}

new Phaser.Game({
  ...gameConfig,
  scene: [BootScene, PreloadScene, IntroScene, GameScene, HUDScene, GameOverScene],
});
